<template>
  <v-container fluid style="height:100%" pa-0 ma-0>
    <StockTable></StockTable>
  </v-container>  
</template>


<script>
import StockTable from './../../components/blocks/StockTable'
export default {
    components: {
      StockTable
    },
    data () {
      return {
        
      }
    },
    mounted() {
    },
    computed: {
      
    },
    created () {},
    methods: {
      
      example(message) {
        
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/Stock.vue